import { addTag, searchTags } from '@/api/tags';
import { RootState } from '@/types/store';
import { Tag, TagsState } from '@/types/tag';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type TagsGetter = GetterTree<TagsState, RootState>;

const state: TagsState = {
  matchingTags: [],
};

const getters: TagsGetter = {};

const actions: ActionTree<TagsState, RootState> = {
  async addNewTag({ commit }, { name }): Promise<void> {
    await addTag(name);
  },
  async getMatchingTags({ commit }, { term }): Promise<void> {
    const tags = await searchTags(term);
    commit('setMatchingTags', { tags });
  },
};

const mutations: MutationTree<TagsState> = {
  setMatchingTags(state: TagsState, { tags }: { tags: Tag[] }): void {
    state.matchingTags = tags;
  },
};

const tags: Module<TagsState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default tags;
